import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ReactComponent as Logo } from "./Assets/svgs/logo.svg";
import sun from "./Assets/svgs/sun-03.svg";
import moon from "./Assets/svgs/moon-01.svg";
import { ReactComponent as Icon } from "./Assets/svgs/download-04.svg";
import cv from "./Assets/images/cv.pdf";
import { ReactComponent as Menu } from "./Assets/svgs/menu.svg";
import { ReactComponent as Cancel } from "./Assets/svgs/Cancel.svg";

function Header({ scrollToSection, home, projects, certification, contact, darkMode, toggleDarkMode }) {
  const [hamburger, setHamburger] = useState(false);
  const [navBar, setNavBar] = useState(false);
  const [activeNav, setActiveNav] = useState("");
  console.log(navBar, activeNav);
  useEffect(() => {
    function handleScrollBackground() {
      if (window.scrollY >= 20) {
        setNavBar(true);
      } else {
        setNavBar(false);
      }
    }
    window.addEventListener("scroll", handleScrollBackground);

    return () => {
      window.removeEventListener("scroll", handleScrollBackground);
    };
  }, []);

  useEffect(() => {
    const observerOptions = {
      root: null,
      rootMargin: "0px",
      threshold: 0.5,
    };

    const observerCallback = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setActiveNav(entry.target.id);
        }
      });
    };

    const observer = new IntersectionObserver(observerCallback, observerOptions);

    const sections = [
      { id: "home", ref: home },
      { id: "contact", ref: contact },
      { id: "certification", ref: certification },
      { id: "projects", ref: projects },
    ];

    sections.forEach((section) => {
      if (section?.ref?.current) {
        observer.observe(section?.ref?.current);
      }
    });

    return () => {
      sections.forEach((section) => {
        if (section?.ref?.current) {
          observer.unobserve(section?.ref?.current);
        }
      });
    };
  }, [contact, certification, home, projects]);

  // const handleNavClick = (section, sectionRef) => {
  //   console.log("sec", section, sectionRef);
  //   setActiveNav(section);
  //   scrollToSection(sectionRef);
  // };
  return (
    <>
      <div className={` z-40 ${darkMode ? " bg-[#25282B]" : "bg-[#f5f6f6]"} p-8  items-center"  left-0  fixed top-0 h-[100px]  w-full justify-center flex items-center`} scrollToSection={scrollToSection}>
        <div className=" w-full flex  justify-between items-center">
          <Link
            onClick={() => {
              window.scrollTo(0, 0);
            }}
            to="/"
          >
            <Logo className={`${darkMode ? "text-[#F5F6F6]" : "text-[#25282B]"}`} />
          </Link>

          <div className={` 100:hidden lg:flex  ${darkMode ? "text-[#F5F6F6]" : "text-[#495055]"} font-inter font-medium text-base w-fit gap-[32px] justify-center items-center`}>
            <Link className=" px-[4px] w-fit flex-col flex justify-center" onClick={() => window.scrollTo(0, 0)} to="/">
              {" "}
              <nav className="hover:text-[#0C0EFF]">Home</nav>
              <div className={` w-full h-px  ${window.location.pathname === "/" ? `${darkMode ? "bg-[#5676FF]" : "bg-[#0C0EFF]"}` : ""} `}></div>
            </Link>
            <Link className=" px-[4px] w-fit flex-col flex justify-center" onClick={() => window.scrollTo(0, 0)} to="/projects">
              {" "}
              <nav className="hover:text-[#0C0EFF]">Projects</nav>
              <div className={` w-full h-px  ${window.location.pathname === "/projects" ? `${darkMode ? "bg-[#5676FF]" : "bg-[#0C0EFF]"}` : ""} `}></div>
            </Link>
            <Link className=" px-[4px] w-fit flex-col flex justify-center" onClick={() => window.scrollTo(0, 0)} to="/certification">
              <nav className="hover:text-[#0C0EFF]">Certification</nav>
              <div className={` w-full h-px  ${window.location.pathname === "/certification" ? `${darkMode ? "bg-[#5676FF]" : "bg-[#0C0EFF]"}` : ""} `}></div>
            </Link>
            <Link className=" px-[4px] w-fit flex-col flex justify-center" onClick={() => window.scrollTo(0, 0)} to="/contact">
              <nav className="hover:text-[#0C0EFF]">Contact</nav>
              <div className={` w-full h-px  ${window.location.pathname === "/contact" ? `${darkMode ? "bg-[#5676FF]" : "bg-[#0C0EFF]"}` : ""} `}></div>
            </Link>
          </div>
          <div className={` ${darkMode ? "text-[#F5F6F6]" : "text-[#495055]"} flex justify-between items-center w-fit gap-1`}>
            <a href={cv} download={cv} className=" 100:hidden lg:flex hover:border-[#0C0EFF] hover:border w-[200px] rounded-[24px] px-2.5 py-1 gap-[6px] justify-center items-center">
              Download Resume
              <Icon className={` ${darkMode ? "text-[#E4E7E9]" : "text-[#25282B]"}`} />
            </a>

            <div onClick={toggleDarkMode} className={` hover:bg-[#505559]  ${darkMode ? " bg-[#40454A]" : " bg-[#FFB600]"} cursor-pointer flex justify-center items-center w-fit p-[8px] rounded-full`}>
              <img src={darkMode ? sun : moon} alt={darkMode ? "sun" : "moon"} />
            </div>
            <div className=" w-fit px-1 100:flex lg:hidden">
              <Menu onClick={() => setHamburger(true)} className={` cursor-pointer ${darkMode ? "text-[#F5F6F6]" : "text-[#25282B]"}`} />
            </div>
          </div>
        </div>
      </div>
      {hamburger && (
        <>
          <div className={` transition-opacity   flex justify-between fixed left-0 top-0 z-50  ${darkMode ? "bg-slate-200" : "bg-slate-700"} bg-opacity-60 backdrop-blur-lg w-full h-full`}>
            <div className={` pt-[40px]  shadow-lg w-[250px] ${darkMode ? "bg-[#25282b]" : "bg-[#f5f6f6]"}  gap-[40px] px-[30px] flex flex-col items-start  py-[25px]`}>
              <Link
                onClick={() => {
                  window.scrollTo(0, 0);
                }}
                to="/"
              >
                <Logo className={`${darkMode ? "text-[#F5F6F6]" : "text-[#25282B]"}`} />
              </Link>
              <div className={` flex flex-col  ${darkMode ? "text-[#F5F6F6]" : "text-[#495055]"} font-inter font-medium text-base w-fit gap-[32px] justify-start items-start`}>
                <Link className=" px-[4px] w-fit flex-col flex justify-center" onClick={() => window.scrollTo(0, 0)} to="/">
                  {" "}
                  <nav>Home</nav>
                  <div className={` w-full h-px  ${window.location.pathname === "/" ? `${darkMode ? "bg-[#5676FF]" : "bg-[#0C0EFF]"}` : ""} `}></div>
                </Link>
                <Link className=" px-[4px] w-fit flex-col flex justify-center" onClick={() => window.scrollTo(0, 0)} to="/projects">
                  {" "}
                  <nav>Projects</nav>
                  <div className={` w-full h-px  ${window.location.pathname === "/projects" ? `${darkMode ? "bg-[#5676FF]" : "bg-[#0C0EFF]"}` : ""} `}></div>
                </Link>
                <Link className=" px-[4px] w-fit flex-col flex justify-center" onClick={() => window.scrollTo(0, 0)} to="/certification">
                  <nav>Certification</nav>
                  <div className={` w-full h-px  ${window.location.pathname === "/certification" ? `${darkMode ? "bg-[#5676FF]" : "bg-[#0C0EFF]"}` : ""} `}></div>
                </Link>
                <Link className=" px-[4px] w-fit flex-col flex justify-center" onClick={() => window.scrollTo(0, 0)} to="/contact">
                  <nav>Contact</nav>
                  <div className={` w-full h-px  ${window.location.pathname === "/contact" ? `${darkMode ? "bg-[#5676FF]" : "bg-[#0C0EFF]"}` : ""} `}></div>
                </Link>
                <a href={cv} download={cv} className="flex  hover:border-[#0C0EFF] hover:border w-full rounded-[24px] hover:px-2.5 py-1 gap-[6px] justify-center items-center">
                  Download Resume
                  <Icon className={` ${darkMode ? "text-[#E4E7E9]" : "text-[#25282B]"}`} />
                </a>
              </div>
            </div>
            <div onClick={() => setHamburger(false)} className={`w-12 cursor-pointer h-12 top-[25px] justify-center flex  items-center right-[40px] relative  ${darkMode ? " bg-gray-600" : "bg-gray-400"} rounded-3xl  `}>
              <Cancel className={`text-[#F5F6F6]`} />
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default Header;
